import { PagedItems } from '@texas/types';
import { httpClient } from '@texas/api/httpClient/httpClient';

export interface CustomsCodeItem {
  id: number;
  branchId: number;
  identifier: string;
  name: string;
  archived: boolean;
}

export interface CustomsCodeListItem extends CustomsCodeItem {
  branchName: string;
}

export interface CustomsCodeSearchQuery {
  searchTerm: string;
  branchId: number;
  includeArchived: boolean;
  sortBy: string;
  sortDesc: boolean;
  page: number;
  pageSize: number;
}

export const customsCodesApi = {
  search: (params: CustomsCodeSearchQuery) =>
    httpClient.get<PagedItems<CustomsCodeListItem>>('metadata/customs-codes', {
      params,
    }),
  getAll: () => httpClient.get<CustomsCodeItem[]>('garp/customscodes/all'),
};
